import * as React from 'react';
import * as styles from './styles.css';

export interface IListingLayoutProps {
  children: React.ReactNode;
}

export function ListingLayout({ children }: IListingLayoutProps) {
  return <div className={styles['container']}>{children}</div>;
}
